import { render, staticRenderFns } from "./offerCodecs.vue?vue&type=template&id=01110a12"
import script from "./offerCodecs.vue?vue&type=script&lang=js"
export * from "./offerCodecs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports